import { useState } from 'react'
import { OrderDto } from '@services/dtos'
import { UpdateOrderDto } from '@services/dtos'

export const useCommentsPopover = () => {
  const [commentsPopover, setCommentsPopover] = useState<{
    anchorEl: HTMLElement | null
    order: OrderDto | null
  }>({ anchorEl: null, order: null })
  const [commentDialogOpen, setCommentDialogOpen] = useState(false)
  const [editingComment, setEditingComment] = useState<
    UpdateOrderDto['comment'] | null
  >(null)
  const handleOpenComments = (
    event: React.MouseEvent<HTMLButtonElement>,
    order: OrderDto,
  ) => {
    setCommentsPopover({ anchorEl: event.currentTarget, order })
  }
  const handleCloseComments = () => {
    setCommentsPopover((prev) => ({ ...prev, anchorEl: null }))
    setEditingComment(null)
  }
  return {
    commentsPopover,
    commentDialogOpen,
    editingComment,
    handleOpenComments,
    handleCloseComments,
    setCommentDialogOpen,
    setEditingComment,
  }
}
